function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "magic/wand subtract");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#2C3137"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.181 15.458a.466.466 0 11.66.658.466.466 0 01-.66-.658zM.662 12.591h.932a1.4 1.4 0 001.398-1.398v-.932a.466.466 0 11.933 0v.932a1.4 1.4 0 001.398 1.398h.932a.466.466 0 010 .932h-.932a1.4 1.4 0 00-1.398 1.399v.932a.466.466 0 01-.933 0v-.932a1.4 1.4 0 00-1.398-1.399H.662a.466.466 0 110-.932zm2.797.934c.132-.177.29-.335.467-.468a2.347 2.347 0 01-.467-.467c-.134.177-.291.334-.468.467.177.133.334.29.468.468zM12.78.473c.258 0 .466.209.466.466v.932a1.4 1.4 0 001.398 1.399h.933a.466.466 0 110 .932h-.933A1.4 1.4 0 0013.246 5.6v.932a.466.466 0 01-.932 0V5.6a1.4 1.4 0 00-1.398-1.398h-.932a.466.466 0 010-.932h.932a1.4 1.4 0 001.398-1.399V.94c0-.257.209-.466.466-.466zm-.468 3.263c.178.133.335.29.468.467.133-.177.29-.334.468-.467a2.357 2.357 0 01-.468-.468c-.133.177-.29.335-.468.468zM.662 3.27A1.4 1.4 0 002.06 1.87a.466.466 0 11.932 0A1.4 1.4 0 004.391 3.27a.466.466 0 010 .932A1.4 1.4 0 002.992 5.6a.466.466 0 01-.932 0A1.4 1.4 0 00.662 4.202a.466.466 0 110-.932zm1.864.933c.133-.177.29-.334.468-.467a2.348 2.348 0 01-.468-.468c-.133.177-.29.335-.467.468.177.133.334.29.467.467z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.294 6.889l1.318-1.318a1.4 1.4 0 011.978 0l15.06 15.06a1.398 1.398 0 010 1.978l-1.318 1.318a1.398 1.398 0 01-1.978 0L5.294 8.867a1.4 1.4 0 010-1.978zm15.72 16.379a.466.466 0 00.659 0l1.318-1.318a.466.466 0 000-.66L12.874 11.174l-1.978 1.977 10.117 10.117zM5.952 8.208l4.284 4.284 1.978-1.978L7.93 6.23a.467.467 0 00-.66 0L5.953 7.548a.467.467 0 000 .66z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.158 16.776l4.515 4.515a.466.466 0 01-.66.659L16.5 17.435a.466.466 0 01.659-.659z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M7.56 22.684h4.66",
  stroke: "#2C3137",
  strokeLinecap: "round"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25"
  }, props), _ref, _ref2);
};

export default SvgComponent;